import { component, observable } from 'knockout-decorators'

import { FeatureToggle } from '@tixa/schema'
import { Authentication, Language } from '~/utils'
import { pageState } from '~/store/page'
import { authState } from '~/components/login/utils/state'
import { CartState } from '../state'

import { createPerson } from '~/components/login/utils/create-person'

import type { SignInOptions } from '~/components/login/utils/options'
import '~/components/login/modal-content/sign-in'
import '~/components/login/modal-content/register'
import '~/components/login/modal-content/lost-password'
import '~/components/login/modal-content/recovery'
import '~/components/login/modal-content/link-accounts'
import '~/components/login/modal-content/logged-in'

import source from './template.html?raw'

@component('cart-user', source)
export class CartUserForm {
  private globalAuthState = Authentication.getInstance()
  private cartState = CartState.get()
  private Locale = Language.getInstance()

  @observable public isOpen = false

  private get options(): SignInOptions {
    return {
      mode: 'cart',
      useJwt: pageState.hasToggle(FeatureToggle.NewLoginEndpoints),
      signedIn: (email) => {
        authState.email = email ?? ''
        this.globalAuthState.setLoggedIn(true)
        this.cartState.hasUser = true
      },
      signedInAsGuest: (email) => {
        authState.email = email ?? ''
        this.cartState.person = createPerson(email ?? '')
        this.cartState.hasUser = true
      },
      signIn: () => {
        /* */
      },
      registerAccount: () => {
        /* */
      },
      lostPassword: (email) => {
        authState.email = email ?? ''
        this.cartState.clear()
        this.globalAuthState.Recover(async () => {
          this.globalAuthState.setLoggedIn(true)
          authState.isLoading = true
          this.cartState.hasUser = true
          await this.cartState.runRequest()
          authState.isLoading = false
        })
      },
      recoverAccount: () => {
        /* */
      },
      linkAccounts: () => {
        /* */
      },
    }
  }

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }
}
